import { RemoteGetActivitiesInProgressCountGroupedByOrganization } from 'data/usecases';
import { GetActivitiesInProgressCountGroupedByOrganizationUseCaseInterface } from 'domain/usecases';
import { makeApiUrlActivitiesInProgressCountGroupedByOrganization } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetActivitiesInProgressCountGroupedByOrganization =
  (): GetActivitiesInProgressCountGroupedByOrganizationUseCaseInterface =>
    new RemoteGetActivitiesInProgressCountGroupedByOrganization(
      makeApiUrlActivitiesInProgressCountGroupedByOrganization(),
      makeAxiosHttpClient(),
    );
